import { Autocomplete, TextField } from '@mui/material';
import { memo } from 'react';
import { Props } from 'react-select';
import { FormHook } from '../form.types';

export interface DropdownTitleOption {
  text: string;
  IconComponent?: any;
}

export interface DropDownProps<T = any, V = any> extends Props, FormHook {
  title?: DropdownTitleOption;
  selected?: any;
  testId?: string;
  onBlur?: () => void;
  isOptionEqualToValue?: (option: T, value: V) => boolean;
}

/**
 * @deprecated
 * Don't use this component, it is using wrong props types from react-select and
 * questionable design choices.
 * If you want to use an autocomplete (aka combobox) component, use the `Autocomplete` component from MUI.
 * @see Autocomplete https://mui.com/components/autocomplete/
 *
 * If you want to use a dropdown (aka select) component, use the `Select` component from MUI.
 * @see Select https://mui.com/components/selects/
 */
export const Dropdown: React.FC<DropDownProps> = memo(({ ...props }) => {
  const handleOnChange = (_: any, value: any) => {
    if (props.onChange)
      props.onChange(value.value, {
        action: 'select-option',
        option: undefined,
      });
  };

  return (
    <>
      <Autocomplete
        disableClearable={true}
        defaultValue={props.value || ''}
        value={props.value || ''}
        onBlur={props.onBlur}
        options={props.options || []}
        onChange={handleOnChange}
        renderInput={(params) => (
          <TextField
            {...params}
            inputProps={{
              ...(params.inputProps || {}),
              'data-testid': props.testId,
            }}
          />
        )}
        isOptionEqualToValue={props.isOptionEqualToValue}
      />
    </>
  );
});
